<template>
  <div class="post_container">
    <Sticky>
      <NavBar :title="`${$t('detail.post.detail')}`" :border="false"/>
    </Sticky>
    <div class="post_content">
      <div class="post_user">
        <Skeleton title avatar avatar-size="32" :row="2" :loading="loading">
          <div class="user_info">
            <div class="user_avatar_sex">
              <span class="user_avatar">
                <img :src="detail.avatar?toImPicUrlThum(detail.avatar):'/static/img/noavatar.gif'" alt="">
              </span>
              <img src="/static/img/female.png" alt="" class="user_sex" v-if="detail.sex == 0">
              <img src="/static/img/male.png" alt="" class="user_sex" v-if="detail.sex == 1">
            </div>
            <p class="name">{{detail.userName}}</p>
          </div>
        </Skeleton>
        <!-- <Skeleton title :loading="loading"> -->
          <div class="text">{{detail.publishContent}}<span class="topic" v-if="detail.themeId">#{{detail.themeName}}#</span></div>
        <!-- </Skeleton> -->
        <!-- 详情图片 -->
        <template v-if="detail.fileType === 'VIDEO'">
          <video id="myVideo"  controls objectFit="contain" width="100%" height="160px" style="margin-top:12px;">
            <source :src="toPicUrl(detail.ossAddress)" type="video/mp4">
            Your browser does not support the video
          </video>
        </template>
        <div class="list" v-if="detail.fileType === 'IMAGE' && detail.ossAddress[0]">
          <div class="item" v-for="(i,index) in detail.ossAddress" :key="index">
            <img :src="toPicUrl(i)" alt="" @click.prevent="imgIndex=index;show=true">
          </div>
        </div>
        <div  class="post_product" v-if="detail.fileType === 'OTHER'">
          <a :href="detail.ossAddress" class="info">{{detail.ossAddress}}</a>
        </div>
        <!-- 定位、小组、话题 -->
        <div class="post_tail">
          <!-- 定位 -->
          <div class="tail_bg gps" v-if="detail.publishAddress">
            <img src="/static/img/gps.png" alt="">
            <span>{{detail.publishAddress}}</span>
          </div>
          <!-- 小组 -->
          <div class="tail_bg group" v-if="detail.groupsName">
            <img src="/static/img/group.png" alt="">
            <span>{{detail.groupsName}}</span>
          </div>
          <!-- 话题 -->
          <div class="tail_bg topic" v-if="detail.themeId">
            <img src="/static/img/topic.png" alt="">
            <span>#{{detail.themeName}}#</span>
          </div>
        </div>
        <!-- 显示点赞数和评论数 -->
        <div class="post-detail-num">
          <!-- 时间 -->
          <p class="time" v-if="timeRule(detail.releaseTime).o === 0">{{$t('detail.post.just')}}</p>
          <p class="time" v-if="timeRule(detail.releaseTime).o === 1">{{$t('detail.post.someMinAgo',{num:timeRule(detail.releaseTime).t})}}</p>
          <p class="time" v-if="timeRule(detail.releaseTime).o === 2">{{$t('detail.post.someHourAgo',{num:timeRule(detail.releaseTime).t})}}</p>
          <p class="time" v-if="timeRule(detail.releaseTime).o === 3">{{$t('detail.post.dayAgo')}}</p>
          <p class="time" v-if="timeRule(detail.releaseTime).o === 4">{{timeRule(detail.releaseTime).t}}</p>
          <!-- 评论数和点赞数 -->
          <div class="num">
            <!-- <p ></p> -->
            <div class="user_c" v-if="detail.thumbUpId>0">{{detail.thumbUpId}} <Icon name="good-job-o"/> </div>
          </div>
        </div>
        <!-- 产品图 -->
        <div class="post_product" v-if="detail.dynamicType == 1">
          <div class="product_img">
            <img :src="toImPicUrlThum(detail.deviceAvatar)" alt="">
          </div>
          <div class="info">
            <p>{{detail.deviceName}}</p>
            <span>{{detail.deviceModel}}</span>
          </div>
        </div>
      </div>
      <!-- 评论 -->
      <div class="post_list">
        <p class="title">{{$t('detail.post.latestComment')}}</p>
        <template>
          <!-- 暂无评论 -->
          <div class="no_comment" v-if="commentList.length<1">
            <img src="/static/img/nonews.png" alt="">
            <p>{{$t('detail.post.noComment')}}</p>
          </div>
          <!-- 评论列表 -->
          <div class="comment_list" v-else>
            <!-- <List @load="getCommentList" v-model="loading"> -->
              <div class="item" v-for="(i,index) in commentList" :key="index">
                <div class="avatar">
                  <div class="avatar_img">
                    <img :src="i.avatar?toImPicUrlThum(i.avatar):'/static/img/noavatar.gif'" alt="">
                  </div>
                  <img src="/static/img/female.png" alt="" class="sex" v-if="detail.sex == 0">
                  <img src="/static/img/male.png" alt="" class="sex" v-if="detail.sex == 1">
                </div>
                <div class="user_b">
                  <div class="user_t">
                    <div class="user_n">
                      <p>{{i.userName}}</p>
                      <span v-if="timeRule(i.commentDate).o === 0">{{$t('detail.post.just')}}</span>
                      <span v-if="timeRule(i.commentDate).o === 1">{{$t('detail.post.someMinAgo',{num:timeRule(i.commentDate).t})}}</span>
                      <span v-if="timeRule(i.commentDate).o === 2">{{$t('detail.post.someHourAgo',{num:timeRule(i.commentDate).t})}}</span>
                      <span v-if="timeRule(i.commentDate).o === 3">{{$t('detail.post.dayAgo')}}</span>
                      <span v-if="timeRule(i.commentDate).o === 4">{{timeRule(i.commentDate).t}}</span>
                    </div>
                    <div class="user_c">{{i.thumbUpCount}} <Icon name="good-job-o" /> </div>
                  </div>
                  <div class="evaluation">
                    <p class="content">{{i.comments}}</p>
                    <div class="reply_list" v-if="i.commentReplyVos.length>0">
                      <template  v-for="(o,t) in i.commentReplyVos">
                        <div class="reply_item" :key="o.id+t" v-if="o.pid==1">
                          <span style="color: #00C8CA" >{{o.userName}}</span>: <span >{{o.comments}}</span>
                        </div>
                        <div class="reply_item" v-if="o.pid==2" :key="o.id+t">
                          <p ><span style="color: #00C8CA">{{o.userName}}</span>{{$t('detail.post.reply')}}<span style="color: #00C8CA">{{o.replyuserName}}</span>: </p><span > {{o.comments}}</span>
                        </div>
                      </template>
                      <div class="reply_more" v-if="i.commentCount>4 && i.commentReplyVos.length < i.commentCount" @click="toViewMore(i.commentsId)">{{$t('detail.post.otherReplies',{num:i.commentCount})}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="more" v-if="isMore">
                <span v-if="!isLoadingMore" @click="toGetMore">{{$t('detail.post.more')}}</span>
                <Loading type="spinner" size="24px" v-if="isLoadingMore"></Loading>
              </div>
            <!-- </List> -->
          </div>
        </template>
      </div>
    </div>
    <template v-if="detail.fileType === 'IMAGE'">
      <Overlay :show="show" :lock-scroll="false" class-name="modalimg" >
        <Swipe :initial-swipe="imgIndex"  class="swiper" indicator-color="#F35219" :stop-propagation="false">
          <SwipeItem v-for="(i,index) in detail.ossAddress" :key="index" class="item" @click="imgUrl = '';show=false">
            <img :src="toPicUrl(i)" alt=""  >
          </SwipeItem>
        </Swipe>
      </Overlay>
    </template>
  </div>
</template>

<script>
import request from '../../api/request'
import { toTime, toPicUrl, toImPicUrlThum, timeRule} from '../../utils/common'
  export default {
    name: '',
    data() {
      return {
        detail: {},
        isLoadingMore: false,
        loading: true,
        id: '',
        show: false,
        imgIndex: '',
        commentList: [],
        isMore:false,
        page: 1,
        pageSize: 10,
      }
    },
    created () {
      this.id =  this.$route.params.id
      if (this.id) {
        this.getData()
        this.getCommentList()
      }
    },
    methods: {
      toImPicUrlThum,
      toPicUrl,
      timeRule,
      getData () {
        this.loading = true
        request('get','cms/community/queryPostNewsById',{id: this.id}).then((res) => {
          if (res.code === 200) {
            // console.log(res)
            // let imgList = res.ossAddress
            this.detail = {
              ...res.data,
              releaseTime: res.data.releaseTime?toTime(res.data.releaseTime): '--',
              ossAddress: res.data.fileType== 'IMAGE'? (res.data.ossAddress.split(',')): res.data.ossAddress
            }
            this.loading = false
          }
        }).catch(() => {
          // console.log(err)
          this.loading = true
        })
      },
      // 获取评论列表
      getCommentList () {
        let data = {
          postNewsId: this.id,
          page: this.page,
          pageSize: this.pageSize
        }
        this.loading = true
        let list = []
        request('get','app/interactive/queryComment',data).then((res) => {
          if (res.code === 200) {
            if (!(res.data.total <this.pageSize *this.page)) {
              this.isMore = true
            } else {
              this.isMore = false
            }
            list = res.data.records.map((o) => ({
              ...o,
              commentDate: o.commentDate?toTime(o.commentDate): '--'
            }))
            this.commentList = this.commentList.concat(list)
            this.loading = false
          }
        }).catch(() => {
          this.loading = true
        })
      },
      toViewMore (id) {
        this.$router.push({name: 'comment',params: {id: id}})
      },
      toGetMore () {
        this.isLoadingMore = true
        this.page++
        this.getCommentList()
        setTimeout(() => {
          this.isLoadingMore = false
        },3000)
      }
    }
  }
</script>

<style lang="less" scoped>
  .post_container{
    width: 100%;
    .post_content{
      width: 325px;
      margin: 0 auto;
      .post_user{
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid #F0F1F2;
        .user_info{
          width: 100%;
          display: flex;
          align-items: center;
          color:#363C54;
          font-size: 16px;
          margin-bottom: 15px;
          .user_avatar_sex{
            width: 40px;
            height: 40px;
            margin-right: 10px;
            position: relative;
            .user_avatar{
              display: block;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              img{
                width: 100%;
                height: auto;
              }
            }
            .user_sex{
              position: absolute;
              width: 13px;
              height: 13px;
              top: 27px;
              left: 27px;
            }
          }
          .name{flex:1;font-weight: bold;}
        }
        .text{
          font-size: 16px;
          font-weight: 500;
          color: #363C54;
          .topic{
            margin-left: 5px;
            color:#00BCBC
          }
        }
        .list{
          width: 100%;
          margin-top:12px;
          .item{
            display: inline-block;
            width: 130px;
            height: 115px;
            margin: 0 6px 6px 0;
            text-align: center;
            overflow: hidden;
            img{
              width: 100%;
              height: auto;
            }
          }
        }
        .post_tail{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          line-height: 14px;
          .tail_bg{
            display: flex;
            align-items: center;
            height: 20px;
            padding: 5px 10px;
            background: #F0F0F0;
            border-radius: 10px;
            margin: 10px 10px 0 0;
            font-size: 13px;
            img{
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }
            span{
              // width: 120px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .gps{color: #999999;}
          .group{color: #81C4EE}
          .topic{color: #81C4EE}
        }
        .post-detail-num{
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #9B9EAA;
          font-size: 13px;
          margin-top: 15px;
          .num{
            display: flex;
          }
        }
        .post_product{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-top: 15px;
          background: #F9F9F9;
          padding: 10px;
          box-sizing: border-box;
          .product_img{
            width: 40px;
            height: 40px;
            margin-right: 10px;
            img{
              width: 100%;
              height: auto;
            }
          }
          .info{
            flex:1;
            font-size: 14px;
            color: #363C54;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            p {
              font-weight: bold;
              margin-bottom: 12px;
            }
          }
        }
      }
      .more{
        text-align: center;
        color: #00C8CA;
        margin: 10px auto;
        font-size: 14px;
      }
    }
  }
</style>